import { LODLevel } from "./types"

export function getLOD(_scale: number): LODLevel {
  return LODLevel.Dot
}
